/**
 * components.jsx — Small, reusable presentational components for the Quote buy-flow.
 * These are stateless UI building blocks used across multiple steps.
 */
import React from 'react';
import {
  ArrowLeftIcon,
  StoreBadgeIcon,
  ChevronDownIcon,
  PinIcon,
  CheckIcon,
  SpinnerIcon,
} from './data';

/* ========================== Typography / Form ========================== */

export function Req() {
  return <span className='cap-req'>*</span>;
}

export function Lbl({ children }) {
  return <label className='cap-lbl'>{children}</label>;
}

export function ErrText({ children }) {
  return <span className='cap-err'>{children}</span>;
}

export function SectionLabel({ children }) {
  return <div className='cap-section-label'>{children}</div>;
}

export function Field({ label, required, children }) {
  return (
    <div className='cap-field'>
      <Lbl>
        {label} {required && <Req />}
      </Lbl>
      {children}
    </div>
  );
}

/* ========================== Decorative ========================== */

export function Highlight({ children }) {
  return (
    <span className='cap-highlight'>
      <span className='cap-highlight__bg' />
      <span className='cap-highlight__text'>{children}</span>
    </span>
  );
}

/* ========================== Navigation ========================== */

export function BackBtn({ onClick, children }) {
  return (
    <div className='cap-backbtn'>
      <button type='button' onClick={onClick} className='cap-backbtn__btn'>
        <ArrowLeftIcon />
        {children}
      </button>
    </div>
  );
}

/* ========================== Data display ========================== */

export function SumRow({ label, value, small }) {
  return (
    <div className='cap-sumrow'>
      <span className='cap-sumrow__label'>{label}</span>
      <span className={'cap-sumrow__value' + (small ? ' cap-sumrow__value--small' : '')}>
        {value}
      </span>
    </div>
  );
}

export function StoreBadge({ top, bottom }) {
  return (
    <div className='cap-store-badge'>
      <StoreBadgeIcon />
      <span className='cap-store-badge__text'>
        <span className='cap-store-badge__top'>{top}</span>
        <span className='cap-store-badge__bottom'>{bottom}</span>
      </span>
    </div>
  );
}

/* ========================== Icon wrappers ========================== */

export function ChevronDown() {
  return <ChevronDownIcon />;
}

export function Pin({ size }) {
  return <PinIcon size={size || 15} />;
}

export function Check({ size }) {
  return <CheckIcon size={size || 11} />;
}
